import { teams } from '../data/teams';

export const getTeamColor = (constructorId) => {
    if (!constructorId) return '#666';

    const normalizedId = constructorId.toLowerCase().replace(/ /g, '_');
    const team = teams.find(t =>
        t.id === normalizedId ||
        normalizedId.includes(t.id) ||
        t.id.includes(normalizedId)
    );

    return team ? team.color : '#666';
};
